import type { ComponentPropsWithoutRef } from 'react';
import styles from './ContainerL.module.css';

export const ContainerL = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => (
  <div
    {...props}
    className={className ? `${styles.containerL} ${className}` : styles.containerL}
  />
);
